import './globals'

$('.btn-menu, .btn-close-menu, .menu-overlay').click(function () {
    if (!_menuOpen) {
        fixScrollbarShifting();
        
        $('body').addClass('fancybox-active compensate-for-scrollbar');
        $(_fixedElements).each(function (index, el) {
            $(el).addClass('compensate-for-scrollbar');
        });

        $('.menu-overlay').fadeIn();
        $('.menu').addClass('active');
    } else {
        $('body').removeClass('fancybox-active compensate-for-scrollbar');
        $(_fixedElements).each(function (index, el) {
            $(el).removeClass('compensate-for-scrollbar');
        });
        fixScrollbarShifting();

        $('.menu-overlay').fadeOut();
        $('.menu').removeClass('active');
    }
    _menuOpen = !_menuOpen;
})

function getScrollbarWidth() {
    var outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

    document.body.appendChild(outer);

    var widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = "scroll";

    // add innerdiv
    var inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);        

    var widthWithScroll = inner.offsetWidth;

    // remove divs
    outer.parentNode.removeChild(outer);

    return widthNoScroll - widthWithScroll;
}

function fixScrollbarShifting() {
    var $style = $('#fancybox-style-noscroll');
    var isStyled = $style.length;
    
    if (isStyled) {
        $style.remove();
    } else {
        $('head').append(`
            <style id="fancybox-style-noscroll" type="text/css">
                .compensate-for-scrollbar{
                    margin-right:${getScrollbarWidth()}px;
                }
            </style>
        `);
    }
}